import { render, staticRenderFns } from "./page-layout-grid.vue?vue&type=template&id=853410d6&scoped=true"
import script from "./page-layout-grid.vue?vue&type=script&lang=js"
export * from "./page-layout-grid.vue?vue&type=script&lang=js"
import style0 from "./page-layout-grid.vue?vue&type=style&index=0&id=853410d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853410d6",
  null
  
)

export default component.exports